import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { User } from 'src/app/models/user.model';
import { AccountService } from 'src/app/services/account.service';
import { AccountComponent } from 'src/app/account/account.component';
import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-account-security',
    templateUrl: './account-security.component.html',
    styleUrls: ['./account-security.component.css'],
    imports: [FormsModule, ReactiveFormsModule, NgClass]
})
export class AccountSecurityComponent {
  private formBuilder = inject(FormBuilder);
  private accountService = inject(AccountService);
  private accountComponent = inject(AccountComponent);

  user: User;
  public UpdatePasswordForm: FormGroup;
  public SetPasswordForm: FormGroup;
  private setFirstPassword: FormControl;
  private setSecondPassword: FormControl;
  private updateFirstPassword: FormControl;
  private updateSecondPassword: FormControl;
  private updateLastPassword: FormControl;
  submittedPasswordForm = false;
  UpdatePasswordFormControl;
  SetPasswordFormControl;
  isChangingPassword = false;

  constructor() {
    this.updateFirstPassword = new FormControl('', [Validators.required, Validators.minLength(6)]);
    this.updateSecondPassword = new FormControl('', [Validators.required, Validators.minLength(6)]);
    this.updateLastPassword = new FormControl('', [Validators.required, Validators.minLength(6)]);
    this.UpdatePasswordForm = this.formBuilder.group({
      updateFirstPassword: this.updateFirstPassword,
      updateSecondPassword: this.updateSecondPassword,
      updateLastPassword: this.updateLastPassword
    }, { validators: this.checkUpdatePasswordForm })
    this.UpdatePasswordFormControl = this.UpdatePasswordForm.controls;
    this.setFirstPassword = new FormControl('', [Validators.required, Validators.minLength(6)]);
    this.setSecondPassword = new FormControl('', [Validators.required, Validators.minLength(6)]);
    this.SetPasswordForm = this.formBuilder.group({
      setFirstPassword: this.setFirstPassword,
      setSecondPassword: this.setSecondPassword
    }, { validators: this.checkSetPasswordForm })
    this.SetPasswordFormControl = this.SetPasswordForm.controls;
    this.initializeUser();
  }

  initializeUser() {
    this.accountService.userObservable
      .pipe(takeUntilDestroyed())
      .subscribe(
        (next: User) => {
          this.user = next;
        }
      )
  }

  checkUpdatePasswordForm: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const pass = group.get('updateFirstPassword')!.value;
    const confirmPass = group.get('updateSecondPassword')!.value
    return pass === confirmPass ? null : { notSame: true }
  }

  checkSetPasswordForm: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const pass = group.get('setFirstPassword')!.value;
    const confirmPass = group.get('setSecondPassword')!.value
    return pass === confirmPass ? null : { notSame: true }
  }

  OnPasswordUpdate() {
    if (!this.isChangingPassword && this.user.has_password) {
      this.isChangingPassword = true;
      return;
    }
    let toastStr = "";
    this.submittedPasswordForm = true;
    if (this.UpdatePasswordForm.invalid || this.updateFirstPassword.value !== this.updateSecondPassword.value) {
      toastStr = "Passwords field must be equal.";
      this.accountComponent.showToast(toastStr, 1);
      this.submittedPasswordForm = false;
      return;
    }
    toastStr = "Updating Password";
    this.accountComponent.showToast(toastStr, 2);
    this.accountService.updatePassword(this.updateLastPassword.value, this.updateFirstPassword.value)
      .subscribe(
        (_response) => {
          toastStr = "Your password is updated";
          this.accountComponent.showToast(toastStr, 0);
          this.isChangingPassword = false;
          this.UpdatePasswordForm.reset()
        },
        (_error) => {
          toastStr = "Updating Password ";
          this.submittedPasswordForm = false;
          toastStr += this.accountService.getErrorStr(_error.status);
          this.accountComponent.showToast(toastStr, 1);
        }
    );
  }

  OnSetPassword() {
    if (!this.isChangingPassword && this.user.has_password) {
      this.isChangingPassword = true;
      return;
    }
    let toastStr = "";
    this.submittedPasswordForm = true;
    if (this.SetPasswordForm.invalid || this.setFirstPassword.value !== this.setSecondPassword.value) {
      toastStr = "Passwords field must be equal.";
      this.accountComponent.showToast(toastStr, 1);
      this.submittedPasswordForm = false;
      return;
    }
    toastStr = "Setting Password";
    this.accountComponent.showToast(toastStr, 2);
    this.accountService.setPassword(this.setFirstPassword.value)
      .subscribe(
        (_response) => {
          toastStr = "Your password is updated";
          this.accountComponent.showToast(toastStr, 0);
          this.isChangingPassword = false;
          this.SetPasswordForm.reset()
        },
        (_error) => {
          toastStr = "Setting Password ";
          this.submittedPasswordForm = false;
          toastStr += this.accountService.getErrorStr(_error.status);
          this.accountComponent.showToast(toastStr, 1);
        }
    );
  }
}
